import { Wording } from '@/types';

export const PILATES_WORDING_DK: Wording = {
  components_header_media_content: 'Træningsprogrammer',
  components_header_media_1: '',
  components_header_text1: 'Opskrifter',
  components_header_text2: 'Blog',
  components_header_members: 'Medlemmer',
  hero_text: 'Hold din krop fleksibel og stærk',
  hero_button_text: 'Start din Pilates-rejse',
  components_ressources_section_title: 'RESSOURCER',
  components_ressources_subheader_text: 'Alle de ressourcer du har brug for til en harmonisk livsstil',
  components_ressources_span_text: 'Lås op for hemmelighederne bag velvære: Dyk ned i en samling af pilatesøvelser og sunde opskrifter, der skaber balance i alle aspekter af dit liv.',
  components_ressources_card_1_title: 'Pilates-tips',
  components_ressources_card_1_text: 'Praktiske råd til at uddybe din praksis og perfektionere din rutine.',
  components_ressources_card_2_title: 'Kost',
  components_ressources_card_2_text: 'Smarte ernæringstips til et sundere og stærkere dig.',
  components_ressources_link: 'Se videoer',
  components_notes_and_google_title_1: 'Pilates',
  components_notes_and_google_title_2: 'Regelmæssig rutine',
  components_notes_and_google_title_3: 'Kostvedligeholdelse',
  components_review_google_text: 'Anmeldelse på Google',
  media_content_section_title: 'TRÆNING',
  media_content_section_subheader_text: 'Vores videoer',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Flere videoer',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Artikler og nyheder',
  text2_section_button_more: 'Flere artikler',
  components_text1_section_title: 'OPSKRIFTER',
  components_text1_subheader_text: 'Nær din krop og dit sind',
  components_text1_span_text: 'Sunde opskrifter til at understøtte dine pilatesrutiner og forbedre dit velbefindende.',
  components_text1_card_1_title: 'Energigivende morgenmad',
  components_text1_card_1_text: 'Vågn op til sprudlende, energigivende måltider.',
  components_text1_card_3_title: 'Power-pakkede frokoster',
  components_text1_card_3_text: 'Opdag lækre og nemme frokostopskrifter designet til din aktive livsstil. Fra farverige salater til proteinrige wraps holder disse opskrifter dig energifyldt og fokuseret.',
  components_text1_card_2_title: 'Middage til restitution',
  components_text1_card_2_text: 'Udforsk en række forskellige magre proteiner, fuldkorn og friske grøntsager for en tilfredsstillende afslutning på din dag.',
  components_text1_link: 'Se alle opskrifter',
  components_footer_text: 'Find balance, træk vejret dybt: Din pilates, din rejse.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreringsnummer',
  components_footer_legal: 'Legal',
  components_footer_terms: 'Vilkår og betingelser',
  components_footer_privacy: 'Privatlivspolitik',
  button_load_more: 'Indlæs mere',
  page_media_1_content_hero_text: 'Pilates træning',
  page_text1_hero_text: 'Opskrifter',
  page_text1_section_title: 'Ernæring',
  page_text1_subheader_text: 'Opskrifter',
  page_text2_hero_text: 'Vores blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Artikler og nyheder',
  enter_email_title: 'Indtast venligst din e-mail for at fortsætte',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Indtast',
  components_login_success_text: 'Login lykkedes!',
  components_card_link_media_content: 'Se nu',
  components_card_link_text1_content: 'Se opskrift',
  components_card_link_text2_content: 'Se artikel',
};